import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { sentryReduxEnhancer } from "@/lib/init-sentry";
import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session"; // Change this line

// import checkoutReducer from "./checkout-slice";
import orderReducer from "./slices/order.slice";
import paymentReducer from "./slices/payment.slice";
import customerReducer from "./slices/customer.slice";
import operatorReducer from "./slices/operator.slice";
import bankIdReducer from "./slices/bankid.slice";
import deliveryReducer from "./slices/delivery.slice";

const operatorPersistConfig = {
  key: "operator",
  storage: sessionStorage, // Use sessionStorage instead of localStorage
};

const rootReducer = combineReducers({
  // checkout: checkoutReducer,
  order: orderReducer,
  payment: paymentReducer,
  bankId: bankIdReducer,
  delivery: deliveryReducer,
  customer: customerReducer,
  operator: persistReducer(operatorPersistConfig, operatorReducer),
});

export const store = configureStore({
  reducer: rootReducer,
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
